import { DtoInclude } from '../../../core/store/dto/dto';
import { RestrictedAccountObjectDto } from '../restricted-account-object/restricted-account-object.dto';

export class ReportLayoutDto extends RestrictedAccountObjectDto {
    @DtoInclude
    title: string;
    @DtoInclude
    description: string;
    @DtoInclude
    entryPoint: string;
    @DtoInclude
    jobType: string;
    @DtoInclude
    localFileSystemPath: string;
}



// WEBPACK FOOTER //
// ./src/vas/business-objects/report-layout/report-layout.dto.ts